<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Helpers',
  computed: {
    ...mapGetters({
      appConfig: 'app/appConfig',
    }),
    appTitle: function(){
      return process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      loading: false,
      menuTop: {},
      menuHeader: {},
      menuFooter: {},
    }
  },
  mounted() {
    const vm = this
    vm.menuTop = vm.checkMenu(vm.appConfig.menus, 'top')
    vm.menuHeader = vm.checkMenu(vm.appConfig.menus, 'header')
    vm.menuFooter = vm.checkMenu(vm.appConfig.menus, 'footer')
  },
  methods: {
    getImage(module, image_id, size = 'web'){
      if(module.files){
        let found = module.files.filter(file => { return image_id ? file.id === image_id : (1 == 1 && this.imageFiles().includes(this.extension(file))) })
        if(found && found.length > 0) switch(size) {
          case 'thumb': 
            // TODO pescare dinamicamente il formato in px dell'immagine
            return found[0] && found[0].thumb ? found[0].thumb[300].file : false
          case 'original':
            return found[0] ? found[0].url : false
          case 'web': 
          default:
            return found[0] && found[0].web ? found[0].web[1280].file : false
        }
      }
      return false
    },
    getBackground(files){
      let background = null
      let images = null
      let cover = null
      if(files && files.length > 0) {
        images = files.filter(file => { return file.is_image })
        cover = images.filter(file => { return file.is_cover })
        background = images[0]
        if(cover && cover.length > 0) background = cover[0]
      }
      if(background) return background.thumb[Object.keys(background.thumb)[0]]['file']
      return false
    },
    getSingleImage(file, size = 'web'){
      if(file){
        switch(size) {
          case 'thumb': 
            // TODO pescare dinamicamente il formato in px dell'immagine
            return file.thumb ? file.thumb[300].file : false
          case 'original':
            return file ? file.url : false
          case 'web': 
          default:
            return file.web ? file.web[1280].file : false
        }
      }
      return false
    },
    checkMenu(menus, position){
      let found = menus.filter(menu => { return menu.position === position })
      if(found.length > 0) return found[0]
      else return false
    },
    checkLogo(type = 'main'){
      switch(type){
        case 'top': 
          return this.appConfig.layout.top_logo || process.env.VUE_APP_TOPBAR_LOGO
        case 'main': 
        default: 
          return this.appConfig.layout.main_logo || false // process.env.VUE_APP_LOGO
      }
    },
    getLogo(type = 'main'){
      switch(type){
        case 'top': 
          return this.appConfig.layout.top_logo ? this.getImage(this.appConfig, this.appConfig.layout.top_logo, 'original') : require(process.env.VUE_APP_TOPBAR_LOGO)
        case 'main': 
        default: 
          return this.appConfig.layout.main_logo ? this.getImage(this.appConfig, this.appConfig.layout.main_logo, 'original') : require(process.env.VUE_APP_LOGO)
      }
    },
    slugify(str) {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()
      // remove accents, swap ñ for n, etc
      let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
      let to   = "aaaaeeeeiiiioooouuuunc------"
      for(var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }
      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes
      return str
    },
    formatDate(field){
      let format = new Date(field)
      return format.getDate()+'/' + (parseInt(format.getMonth())+1) +'/'+format.getFullYear()
    },
    getYear(){
      let format = new Date()
      return format.getFullYear()
    },
    extension(file){
      let re = /(?:\.([^.]+))?$/
      return re.exec(file.file)[1]
    },
    downloadableFiles(){
      return ['csv','xlsx','xls','pdf','mp4','mp3']
    },
    imageFiles(){
      return ['jpg','png']
    },
    hasImages(files){
      let attach = false
      files.forEach(file => {
        if(this.imageFiles().includes(this.extension(file))) attach = true
      })
      return attach
    },
    hasAttachments(files){
      let attach = false
      files.forEach(file => {
        if(this.downloadableFiles().includes(this.extension(file))) attach = true
      })
      return attach
    },
    getImagesFiles(files){
      return files.filter(file => {
        return this.imageFiles().includes(this.extension(file))
      })
    },
    getAttachableFiles(files){
      return files.filter(file => {
        return this.downloadableFiles().includes(this.extension(file))
      })
    },
    getMainLogo(){
      return this.getImage(this.appConfig, this.appConfig.layout.main_logo, 'original')
    },
    rgbaColor(hex, alpha = 1) {
      if (!hex) return `rgba(255, 255, 255, ${alpha})`;
      let c = hex.replace('#', '');
      if (c.length === 3) {
        c = c.split('').map(char => char + char).join('');
      }
      const r = parseInt(c.substr(0, 2), 16);
      const g = parseInt(c.substr(2, 2), 16);
      const b = parseInt(c.substr(4, 2), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    repeating(value){
      let repeatings = value.split('|')
      let output = null
      if(repeatings.length > 0){
        output = '<div class="flex flex-col">'
        repeatings.forEach(repeating => {
          if(repeating.startsWith('http://') || repeating.startsWith('https://')) {
            repeating = `<a href="${repeating}" target="_blank" class="bg-blue-100 text-blue-900 py-1 px-2 rounded-sm">${repeating}</a>`
          }else{
            repeating = `<span>${repeating}</span>`
          }
          output += `<div class="my-1.5">${repeating}</div>`
        })
        output += '</div>'
      }
      return output
    },
    getColor(tone, int) {
      switch(tone){
        case 'transparent': return 'transparent'
        case 'white': return 'white'
        case 'black': return 'black'
        default: return `${tone}-${int}00`
      }
    },
    getFormattedContent(content){
      return content.replace(/<p><\/p>/g, '<br/>')
    }, 
  }
}
</script>
